//Empezamos
const apiEndpoint = "https://todoparalaindustria-b2b.lineagrafica.es";


 class CustomerFormAPP {
    container = null;
    // endpoint = 'https://padel-market-plus.myshopify.com/pages/b2b-register';
     translations = {
        attachmentEmpty: 'You must attach a file.',
        socialNameEmpty: 'You must enter a social name.',
        cifnifEmpty: 'You must enter a cif/nif.',
        invalidEmail: 'You must enter a valid email.',
        phoneEmpty: 'You must enter a phone number.'
    };
   
domElements = {
        submitButton: null,
        cancelButton: null,
        socialName: null,
        cifnif: null,
        email: null,
        phone: null
    };

   


    constructor(container) {
        this.container = document.querySelector(container);
        if (!this.container) {
            throw new Error('Container element not found, skipping app bootstrap');
        }
        this.domElements.email = this.container.querySelector('#email');
        this.domElements.socialName = this.container.querySelector('#commercial_name');
        this.domElements.cifnif = this.container.querySelector('#id_number');
        this.domElements.phone = this.container.querySelector('#phone');  // New phone field
        this.domElements.submitButton = this.container.querySelector('button[type="submit"]');
        this.domElements.cancelButton = this.container.querySelector('#cancelButton');
    

        this.prepareSubmit();
        this.prepareCancel();
    }

    prepareSubmit() {
        this.container.addEventListener('submit', (event) => {
            event.preventDefault();
            this.doSubmit();
        });

        this.domElements.submitButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.doSubmit();
        });
    }

    prepareCancel() {
        this.domElements.cancelButton.addEventListener('click', () => {
            this.container.reset();
        });
    }

    validateEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }


    validateText(input, errorMessage) {
        if (input.value.trim() === '') {
            this.showError(input, errorMessage);
            return false;
        }
        return true;
    }

    validateEmailField(input, errorMessage) {
        if (!this.validateEmail(input.value)) {
            this.showError(input, errorMessage);
            return false;
        }
        return true;
    }

    validateSelect(input, errorMessage) {
        if (input.value === '') {
            this.showError(input, errorMessage);
            return false;
        }
        return true;
    }
    showSuccessModal() {
        const modal = document.getElementById('successModal');
        const span = document.getElementsByClassName('close')[0];

        // When the user clicks on <span> (x), close the modal
        span.onclick = function() {
            modal.style.display = "none";
        }

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }

        modal.style.display = "block";
    }


    showError(input, message) {
        const error = document.createElement('div');
        error.className = 'error-message';
        error.textContent = message;
        input.parentElement.appendChild(error);
    }

    doSubmit() {
        // Clear previous error messages
        const errorElements = this.container.querySelectorAll('.error-message');
        errorElements.forEach(el => el.remove());

        let isValid = true;

      
        // Validate each field
    if (this.domElements.socialName) {
            if (!this.validateText(this.domElements.socialName, this.translations.socialNameEmpty)) isValid = false;
        }
        if (this.domElements.cifnif) {
            if (!this.validateText(this.domElements.cifnif, this.translations.cifnifEmpty)) isValid = false;
        }
        if (this.domElements.email) {
            if (!this.validateEmailField(this.domElements.email, this.translations.invalidEmail)) isValid = false;
        }
        if (this.domElements.phone) {
            if (!this.validateText(this.domElements.phone, this.translations.phoneEmpty)) isValid = false;
        }

        if (isValid) {
            this.submitForm();
        }
    }

    async submitForm() {
        //Ge the form data
        const formData = new FormData(this.container);

        //Now, inflate / create the payload
        const payload = {
            firstname: formData.get('first_name'),
            lastname: formData.get('last_name'),
            email: formData.get('email'),
            idnumber: formData.get('id_number'),
           commercial_name: formData.get('commercial_name'),
        //    business_name: formData.get('business_name'),
            phone: formData.get('phone'),  // New phone field
          //  businesstype: formData.get('business_type'),
            // files: this.files,
            shop: Shopify.shop
        };
        console.log(payload)
        //Execute the request
       const registerResponse = await fetch(`${apiEndpoint}/api/b2b/register`, {

                method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        //check request results
        const registerResponseDecoded = await registerResponse.json();
        if (!registerResponse.ok) {
            throw new Error('Error al enviar el formularios');
        }
        this.showSuccessModal();
    }
}

document.addEventListener("DOMContentLoaded", function() {
    new CustomerFormAPP('#create_customer');
});



